import React from "react";
import "./category.css";
import Input from "../../components/Input";

export default function Category({ handleChange }) {
  return (
    <div>
      <h3 className="sidebar-title">Category</h3>
      <div>
        <label className="sidebar-level-container">
          <input
            type="radio"
            onClick={() => handleChange("all")}
            name="categ"
          />
          <span className="checkMark"></span>All
        </label>
        <Input
          value="sneakers"
          title="Sneakers"
          name="categ"
          handleChange={handleChange}
        />
        <Input
          handleChange={handleChange}
          value="flats"
          title="Flats"
          name="categ"
        />
        <Input
          handleChange={handleChange}
          value="sandals"
          title="Sandals"
          name="categ"
        />
        <Input
          handleChange={handleChange}
          value="heels"
          title="Heels"
          name="categ"
        />
      </div>
    </div>
  );
}
